import { SuggestionCard } from './suggestion-card';
import { ValidateButton } from './validate-button';
import { ValidationIssueAlert } from './validation-issue-alert';
import { VALIDATED_ADDRESS_STATUS } from '../../../../../../../address/address-validation.api';

import type { AddressValidationResultItem, MatchedAddress } from '../../../../../../../address/address-validation.api';

type AddressValidationProps = {
  result: AddressValidationResultItem | null;
  isValidating: boolean;
  isAddressComplete: boolean;
  onValidate: () => void;
  onApply: (matched: MatchedAddress) => void;
};

export const AddressValidation = ({ result, isValidating, isAddressComplete, onValidate, onApply }: AddressValidationProps) => {
  if (result?.status === VALIDATED_ADDRESS_STATUS.VERIFIED) {
    return <SuggestionCard isValidating={isValidating} onApply={onApply} onValidate={onValidate} result={result} />;
  }

  if (result?.status === VALIDATED_ADDRESS_STATUS.WARNING || result?.status === VALIDATED_ADDRESS_STATUS.ERROR) {
    return <ValidationIssueAlert isValidating={isValidating} onValidate={onValidate} result={result} />;
  }

  return <ValidateButton isAddressComplete={isAddressComplete} isValidating={isValidating} onValidate={onValidate} />;
};
